import { ContextSort, NumericSortOrder } from '@ardoq/data-model';
import { SortAttribute } from './sortTypes';

export const getDefaultSort = (): ContextSort => ({
  attr: SortAttribute.ORDER,
  name: 'Order',
  order: NumericSortOrder.ASC,
});
//
